import { stringLiteralArray } from './utils';

// NOTE: Ensure these have the format `voyage:action`
export const KAFKA_VOYAGE_ACTIONS = stringLiteralArray([
  'voyage:created',
  'voyage:updated',
  'voyage:deleted',
]);
